import { fetchTrailersUser } from './trailers';
import { getCookie } from '../utils/csrf';

// Constants
const SET_MOVES = 'moves/SET_MOVES';
const ADD_MOVE = 'moves/ADD_MOVE';
const UPDATE_MOVE = 'moves/UPDATE_MOVE';
const REMOVE_MOVE = 'moves/REMOVE_MOVE';
const ACCEPT_MOVE = 'moves/ACCEPT_MOVE';
const FINISH_MOVE = 'moves/FINISH_MOVE';

// Action Creators
export const setMoves = (moves) => ({
  type: SET_MOVES,
  payload: moves,
});

export const addMove = (move) => ({
  type: ADD_MOVE,
  payload: move,
});

export const updateMove = (move) => ({
  type: UPDATE_MOVE,
  payload: move,
});

export const removeMove = (moveId) => ({
  type: REMOVE_MOVE,
  payload: moveId,
});

export const acceptMoveAction = (move) => ({
  type: ACCEPT_MOVE,
  payload: move,
});

export const finishMoveAction = (move) => ({
  type: FINISH_MOVE,
  payload: move,
});

// Thunks
export const fetchMoves = () => async (dispatch) => {
  const response = await fetch('/api/moves', {
    headers: {
      'X-CSRF-TOKEN': getCookie('csrf_token')
    },
    credentials: 'include'
  });

  if (response.ok) {
    const moves = await response.json();
    dispatch(setMoves(moves));
    return moves;
  }
  return null;
};

export const createMove = (moveData) => async (dispatch) => {
  try {
    const response = await fetch('/api/moves', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': getCookie('csrf_token')
      },
      credentials: 'include',
      body: JSON.stringify(moveData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to create move');
    }

    dispatch(addMove(data));
    return data;
  } catch (error) {
    console.error('Error creating move:', error);
    throw error;
  }
};

export const acceptMove = (moveId) => async (dispatch) => {
  const response = await fetch(`/api/moves/${moveId}/accept`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': getCookie('csrf_token')
    },
    credentials: 'include'
  });

  if (response.ok) {
    const move = await response.json();
    console.log('Accept move response:', move);
    dispatch(acceptMoveAction(move));
    return move;
  }
  return null;
};

export const finishMove = (moveId) => async (dispatch) => {
  const response = await fetch(`/api/moves/${moveId}/finish`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': getCookie('csrf_token')
    },
    credentials: 'include'
  });

  if (response.ok) {
    const move = await response.json();
    dispatch(finishMoveAction(move));
    // Refresh trailers state to reflect the new locations
    await dispatch(fetchTrailersUser(move.account_id));
    return move;
  }
  return null;
};

export const cancelMove = (moveId) => async (dispatch) => {
  const response = await fetch(`/api/moves/${moveId}/cancel`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': getCookie('csrf_token')
    },
    credentials: 'include'
  });

  if (response.ok) {
    const move = await response.json();
    dispatch(updateMove(move));
    return move;
  }
  return null;
};

// Initial State
const initialState = {
  list: [],
  current: null,
};

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_MOVES:
      return {
        ...state,
        list: action.payload,
      };
    case ADD_MOVE:
      return {
        ...state,
        list: [...state.list, action.payload],
      };
    case UPDATE_MOVE:
    case ACCEPT_MOVE:
    case FINISH_MOVE:
      console.log('Reducer - Before update:', state.list);
      console.log('Reducer - Updating move:', action.payload);
      const updatedState = {
        ...state,
        list: state.list.map((move) =>
          move.id === action.payload.id ? action.payload : move
        ),
      };
      console.log('Reducer - After update:', updatedState.list);
      return updatedState;
    case REMOVE_MOVE:
      return {
        ...state,
        list: state.list.filter((move) => move.id !== action.payload),
      };
    default:
      return state;
  }
}
